
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from "@components/common/Layout";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Link from "next/link"
import InputNumber from "@components/ui/Input/number";
import {GetServerSideProps} from "next";
import storevio from "@lib/api";
import {useAddItem, useCart, useRemoveItem} from "@framework/cart";
import {formatPrice} from "@lib/formatPrice";
import Image from '@components/common/Image'
import {useForm} from "react-hook-form";
import React, {useEffect, useState} from "react";
import {useUI} from "@components/ui";
import {useRouter} from "next/router";
import {getProductPath} from "@lib/links";
import getRecommendedProducts from "@framework/api/endpoints/products/getRecommendedProducts";
import updateInformationCart from "@framework/api/endpoints/updateCart";
import useTranslation from "next-translate/useTranslation";
import Price from "@components/common/Price";
import getDiscountCoupon from "@framework/api/endpoints/getDiscountCoupon";
import {settings} from "nprogress";
import useData from "@commerce/utils/use-data";
import {MaximumCapacity} from "@commerce/utils/errors";
import useCustomer from "@framework/customer/use-customer";

// @ts-ignore
 async function _getServerSideProps({params, locale}: GetServerSideProps) {

    const topNavLinks = await storevio.getMenu(locale!,'top')
    const bottomNavLinks = await storevio.getMenu(locale!,'bottom')
    const settings = await storevio.getSettings(locale!);

    return {
        props: {
            topNavLinks,
            bottomNavLinks,
            settings,
        },
    }
}

export default function CartItems({...props}) {

    const {t} = useTranslation("common")
    const router = useRouter();
    const addItem = useAddItem()
    const deleteItem = useRemoveItem();
    const { data, mutate } = useCart()
    const { data: customer, isLoading: isLoadingCustomer, error: customerError } = useCustomer();

    const {openModal, setModalView, giftColor, setGiftColor} = useUI()
    const [recommended, setRecommended] = useState<any>({});

    const { register, handleSubmit, watch, reset } = useForm();
    const giftWatch = watch('gift', false);
    const [discountInput, setDiscountInput] = useState<string | null>(null);
    const [discountMessage, setDiscountMessage] = useState<{message: string, type: string} | null>(null);
    const [maximumCapacityError, setMaximumCapacityError] = useState<{id: string, message: string, type: string} | null>(null);
    const [customerType, setCustomerType] = useState<string>('fo');

    useEffect(() => {
        if (!isLoadingCustomer && customer) {
            setCustomerType(customer?.group.name);
        }
    }, [customer, isLoadingCustomer])

    useEffect(() => {
        if ( data?.giftColor != undefined && data?.giftColor !== null && data?.giftColor !== '') {
            reset({
                gift: true,
                giftColor: data?.giftColor,
                giftMessage: data?.giftMessage,
            })
        }


        if (data) {
            // @ts-ignore
            async function fetchData()
            {
                const pom: any = {};
                const push = data?.items?.map(async (item: any) => {
                    const recommended = await getRecommendedProducts(item.id, router.locale);
                    recommended?.map((p: any) => {
                        pom[p.product.id] = p;
                    })
                    //pom[item.id] = await getRecommendedProducts(item.id, router.locale);
                })
                if (data?.items) {
                    // @ts-ignore
                    await Promise.all(push);
                }
                setRecommended(Object.values(pom));
            }
            fetchData();
        }
    }, [data])
    useEffect(() => {
        if (giftColor) {
            reset({
                gift: true,
                giftColor: giftColor.color,
            })
        }
    }, [giftColor])

    useEffect(() => {
       mutate()
    }, [router.locale])

    const handleSelectGift = () => {
        if (!giftWatch) {
            setModalView('GIFT');
            openModal();
            reset({
                gift: false
            })
        }
    }
    const updateCart = async (val: number, productId: string, variantId: string | null) => {
        try {
            const data = await addItem({
                quantity: val,
                productId: productId,
                variantId: variantId,
            })
            setMaximumCapacityError(null);


            if (data && data?.discount && (data?.totalPriceItems.amount < data?.discount)) {
                setDiscountMessage({
                    message: 'Slevový kupon byl odebrán, jelikož lze uplatnit pouze pro částku ' + formatPrice(data?.discount, 1, props.settings.currency, true) + " a více.",
                    type: 'red',
                })

                await updateInformationCart({
                    discount: null,
                    discountType: null,
                    discountCode: null,
                })
                mutate()
            }
        } catch (e) {
            if (e instanceof MaximumCapacity) {
                mutate();
                setMaximumCapacityError(null);
                setMaximumCapacityError({
                    id: productId + variantId ?? '',
                    message: t('Překročili jste maximální objednatelné množství'),
                    type: 'red',
                })
                console.log("chyba");
            } else {
                throw e;
            }
        }
    }
    const handleDelete = async (id: string, variantId?: string) => {
        deleteItem({ id, variantId: (variantId ? variantId : '') });
    }
    const onSubmit = async (data: any) => {
            await updateInformationCart({
                giftColor: data.gift ? data.giftColor : null,
                giftMessage: data.gift ? data.giftMessage : null,
            })
        await router.push('/cart/myInformation')
    }
    const recommendedBuy = async (product: any) => {
        if (product.hasVariants) {
            await router.push(getProductPath(product.slug))
        } else {
            await addItem({
                quantity: 1,
                productId: product.id,
                variantId: null,
            })
            window.scrollTo({ top: 0})

        }
    }

    const handleValidDiscountCode = async () => {
        try {
            setDiscountMessage(null)
            const result = await getDiscountCoupon(discountInput!);

            if (data?.totalPrice.amount && (result.discount/props.settings.currency.exchangeRate) > data?.totalPrice.amount && result.discountType === 'fixed') {
                setDiscountMessage({
                    message: 'Slevový kupon lze uplatnit až od částky ' + formatPrice(result.discount, 1, props.settings.currency, true),
                    type: 'red',
                })
            } else {
                await updateInformationCart({
                    discount: result.discount,
                    discountType: result.discountType,
                    discountCode: result.code,
                    isVoucher: result.type === 'voucher'
                })
                mutate()
                setDiscountInput(null)
            }
            // useCart()
                // alert(JSON.stringify(result));
        } catch (e) {
            setDiscountMessage({
                message: 'Slevový kupón je neplatný nebo byl již použit',
                type: 'red',
            })
        }
    }

    const discountInputDown = async (e: any) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            await handleValidDiscountCode();
        }
    }

    const removeDiscount = async (e: any) => {
        e.preventDefault();
        await updateInformationCart({
            discount: null,
            discountType: null,
            discountCode: null,
        })
        mutate()
    }

    return (
            <main role="main">
                <div className="page-wrapper">

                    <section className="cart-wrap">
                        <div className="cart-wrap-title">
                            <h2>
                                {t("Můj nákupní košík")}
                            </h2>
                            <Link href={"/category"}><a className="cart-wrap-continue">{t("Pokračovat v nákupu")}</a></Link>
                        </div>

                        {data?.items === undefined && <div className="cart-empty">
                            <div className="container">
                                <p>
                                    {t("Košík je prázdný")}
                                    <br/>
                                    <strong>{t("Podívejte se na naši nabídku")}</strong>
                                </p>
                                <Link href={"/category"}>
                                    <a className="btn btn-background btn-arrow-right">
                                        {t("Přejít na produkty")}
                                    </a>
                                </Link>
                            </div>
                        </div>}

                        {data?.items != undefined && <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="cart-wrap-sides">
                                <div className="cart-wrap-left">
                                    {data?.items?.map((item, index) => <>
                                        <div className="cart-item">
                                        <div className="cart-item-image">
                                            <Link href={`/product/${item.slug}`}>
                                                <a>
                                                    {item.variant && <><Image src={item.variant.mainPhoto!} width={555} height={543}/></>}
                                                    {!item.variant && <Image src={item.mainPhoto} width={555} height={543}/>}
                                                </a>
                                            </Link>
                                        </div>
                                        <div className="cart-item-content">
                                            <h3>
                                                <Link href={`/product/${item.slug}`}>
                                                    <a>{item.name}</a>
                                                </Link>
                                            </h3>
                                            {item.code && <div className="cart-item-code">
                                                {t("Kód produktu")}: {item.code}
                                            </div>}

                                            {(item.hasVariants && item.variant.code) && <div className="cart-item-code">
                                                {t("Kód produktu")}: {item.variant.code}
                                            </div>}

                                            {item.hasVariants && <p>
                                                {item.variant.params?.map((param) => <>{param.param.name}: {param.value.value}<br /></>
                                            )}
                                            </p>}

                                            {(maximumCapacityError && maximumCapacityError.id === (item.id + item.variant?.id ?? '')) && <div className={`${maximumCapacityError.type}-alert`}>{maximumCapacityError.message}</div>}
                                            <div className="cart-item-content-settings">
                                                <InputNumber min={1} onChange={(val: number | null) => updateCart(val ? val : 1, item.id, item.variant?.id)} resetValue={(maximumCapacityError !== null && maximumCapacityError.id === (item.id + item.variant?.id ?? ''))} value={parseInt(item.quantity.toString())} />
                                                {item.variant && <div className="price">
                                                    <Price
                                                        amount={item?.variant.price.amount} vat={item?.variant.price?.vat}
                                                        quantity={item.quantity}
                                                        amountWithoutVat={item?.variant.price.amountWithoutVat}
                                                        actionPrice={ {
                                                            amount: item?.variant?.actionPrice.amount,
                                                            amountWithoutVat: item?.variant.actionPrice.amountWithoutVat
                                                        }}
                                                        priceOption={props.settings.currency} />
                                                    {/*formatPrice((item.variant.actionPrice ? item.variant.actionPrice : item.variant.price)*item.quantity, props.settings.currency)*/}
                                                    <small style={{fontSize: '1.7rem', textAlign: 'left', display: 'block', marginTop: 10}}>
                                                        {/*formatPrice(item.variant.actionPrice ? item.variant.actionPrice : item.variant.price, props.settings.currency)*/}
                                                        <Price {...item.variant?.price}
                                                               showOriginalIfExistDiscount={false}
                                                               actionPrice={ {
                                                                   amount: item?.variant?.actionPrice.amount,
                                                                   amountWithoutVat: item?.variant.actionPrice.amountWithoutVat
                                                               }}
                                                               priceOption={props.settings.currency} />
                                                    </small>
                                                </div>}
                                                {!item.variant && <div className="price">
                                                    {/*formatPrice((item.actionPrice ? item.actionPrice : item.price)*item.quantity, props.settings.currency)*/}
                                                    <Price
                                                        amount={item?.price.amount}
                                                        vat={item?.price?.vat}
                                                        quantity={item.quantity}
                                                        amountWithoutVat={item?.price.amountWithoutVat}
                                                        actionPrice={ {
                                                            amount: item?.actionPrice.amount,
                                                            amountWithoutVat: item?.actionPrice.amountWithoutVat
                                                        }}
                                                        priceOption={props.settings.currency} />
                                                    <small style={{fontSize: '1.7rem', textAlign: 'left', display: 'block', marginTop: 10}}>
                                                        <Price {...item?.price} actionPrice={ {
                                                            amount: item?.actionPrice.amount,
                                                            amountWithoutVat: item?.actionPrice.amountWithoutVat
                                                        }} showOriginalIfExistDiscount={false} priceOption={props.settings.currency} />
                                                        {/*formatPrice(item.actionPrice ? item.actionPrice : item.price, props.settings.currency)*/}
                                                    </small>
                                                </div>}
                                                <div className="cics-tools">
                                                    <Link href={`/product/${item.slug}`}>
                                                        <a className="link-more">
                                                            {t("Zobrazit detail")}
                                                        </a>
                                                    </Link>
                                                    <a href="#" onClick={(e) => {e.preventDefault(); handleDelete(item.id, item.variant?.id)}} className="link-remove">
                                                        {t("Odstranit")}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        {/*recommended[item.id]?.length > 0 && <div className="products-recommended">
                                        <h3>
                                            {t("Doporučené produkty")}
                                        </h3>
                                        <div className="products-recommended-items">
                                            {recommended[item.id]?.map((rp: any, index: number) =>
                                                <div key={index} className={"item"}>
                                                    <div className="pr-image" style={{marginRight: '10px'}}>
                                                        <Link href={getProductPath(rp.product.slug)}>
                                                            <a>
                                                                <Image src={rp.product.mainPhoto} width={160} height={106} fit={"contain"} />
                                                            </a>
                                                        </Link>
                                                    </div>
                                                    <div className="rp-text">
                                                        <h4>
                                                            <Link href={getProductPath(rp.product.slug)}>
                                                                <a>{rp.product.name}</a>
                                                            </Link>
                                                        </h4>
                                                        <strong>{formatPrice(rp.product.price, props.settings.currency)}</strong>
                                                    </div>
                                                    <a href={"#"} onClick={(e) => { e.preventDefault(); recommendedBuy(rp.product) }} className={"btn-buy"}>{t("Koupit")}</a>
                                                </div>)}
                                        </div>
                                    </div>*/}

                                        {(recommended?.length > 0 && 0 == index) && <div className="products-recommended">
                                        <h3>
                                            {t("Doporučené produkty")}
                                        </h3>
                                        <div className="products-recommended-items">
                                            {recommended?.map((rp: any, index: number) =>
                                                <div key={index} className={"item"}>
                                                    <div className={"pr-content"}>
                                                        <div className="pr-image" style={{marginRight: '10px'}}>
                                                            <Link href={getProductPath(rp.product.slug)}>
                                                                <a>
                                                                    <Image src={rp.product.mainPhoto} width={160} height={106} fit={"contain"} />
                                                                </a>
                                                            </Link>
                                                        </div>
                                                        <h4>
                                                            <Link href={getProductPath(rp.product.slug)}>
                                                                <a>{rp.product.name}</a>
                                                            </Link>
                                                        </h4>
                                                    </div>
                                                    <div className={"pr-footer"}>
                                                            <strong className={"pr-price"}>{formatPrice(rp.product.price, 1, props.settings.currency)}</strong>
                                                            <a href={"#"} onClick={(e) => { e.preventDefault(); recommendedBuy(rp.product) }} className={"btn-buy"}>{t("Koupit")}</a>
                                                    </div>
                                                </div>)}
                                        </div>
                                    </div>}
                                    </>)}
                                </div>
                                <div className="cart-wrap-right">
                                    {giftWatch && <div className="cart-line">
                                        {t("Dárkové balení")} <span className={"price"}>{formatPrice(99, 1, props.settings.currency)}</span>
                                    </div>}
                                    <div className="cart-line">
                                        {t("Mezisoučet")} {/*<span>{formatPrice(data?.totalPrice ? data?.totalPrice + (giftWatch ? 99 : 0) : 0, props.settings.currency)}</span>*/}
                                        <span className={"price"}>
                                           <Price
                                                amount={data?.totalPriceItems.amount}
                                                vat={0}
                                                amountWithoutVat={data?.totalPriceItems.amountWithoutVat}
                                                showOriginalIfExistDiscount={false}
                                                recalculate={false}
                                                priceOption={props.settings.currency} />
                                        </span>
                                    </div>
                                    {data.discount && <div className="cart-line">
                                        {t("Sleva", { discount: "" })}
                                        <span className={"price"}>
                                            {data.discountType === 'fixed' ? formatPrice(data.discount,1, props.settings.currency) : data.discount + '%'}
                                            <a href="#" onClick={removeDiscount} className="coupon-remove" />
                                        </span>
                                    </div>}
                                    {(customerType !== 'b2b') && <div className="discount-wrap">
                                        {discountMessage && <div className={`${discountMessage.type}-alert`}>{discountMessage.message}</div>}
                                        <label>
                                            {t("Zadat slevový kód")}
                                        </label>
                                        <button type="button" onClick={handleValidDiscountCode} className="btn">{t("Použít")}</button>
                                        <input type="text" value={discountInput ? discountInput : ''} onKeyDown={discountInputDown} onChange={(e) => setDiscountInput(e.currentTarget.value)} />
                                    </div>}
                                    <div className="cart-total">
                                        {t("Celkem")}
                                        {/*<span>{formatPrice(data?.totalPrice ? data?.totalPrice + (giftWatch ? 99 : 0) : 0, props.settings.currency)}</span>*/}
                                        <Price
                                            amount={data?.totalPrice.amount}
                                            vat={0}
                                            amountWithoutVat={data?.totalPrice.amountWithoutVat}
                                            showOriginalIfExistDiscount={false}
                                            priceOption={props.settings.currency}
                                            recalculate={false}
                                            showLabel={true}
                                        />
                                    </div>


                                    {(((data?.totalPrice.amount < 3000 && !(data.discount && data.isVoucher)) || (data?.totalPriceItems.amount < 3000)) && router.locale === 'cs' && customerType !== 'b2b') && <div className="red-alert alert-delivery">
                                        {t("DeliveryFree", { amount: formatPrice(3000-((data.discount && data.isVoucher) ? data?.totalPriceItems.amount : data?.totalPrice.amount), 1, props.settings.currency, true) })}
                                    </div>}
                                    {/*<div className="form-wide">
                                        <input type="checkbox" {...register('createAccount')} id="uch1" />
                                            <label htmlFor="uch1">{t("Vytvorit účet s objednávkou")}</label>
                                            <div className="label-desc">
                                                {t("Možnost sledování zásilky, uložení údajů pro další nákup")}
                                            </div>
                                    </div>*/}
                                    {false && <div className="form-wide" onClick={handleSelectGift}>
                                        <input type="checkbox" {...register('gift')} id={"uch2"} />
                                            <label htmlFor="uch2">{t("Chci dárkové balení včetně vzkazu")} ({formatPrice(99, 1, props.settings.currency)})</label>

                                        {(giftColor && giftWatch) && <div className="label-desc">
                                                <a href="#" onClick={handleSelectGift}><img
                                                    src={giftColor.smallImage} alt="" /></a>
                                            </div>}
                                    </div>}
                                    {giftWatch && <div className="form-wide">
                                        <div className="textarea-wrap">
                                            <textarea placeholder="Napište váš vzkaz" {...register('giftMessage')} />
                                        </div>
                                    </div>}
                                    <div className="form-wide">
                                        <button type={"submit"} className="btn">{t("Pokračovat")}</button>
                                    </div>
                                    <ul className="cart-info">
                                        <li>
                                            <img src="/images/cart-info01.svg" alt="" />
                                                <strong>
                                                    {t("Doprava")}
                                                </strong>
                                            {t('GLS, Osobní odběr, Balíkovna, PPL, Česká pošta')}
                                        </li>
                                        <li>
                                            <img src="/images/cart-info02.svg" alt="" />
                                                <strong>
                                                    {t("Platba")}
                                                </strong>
                                            {t('Platba při převzetí, Platba dobírkou, Platební kartou, Bankovním převodem')}
                                        </li>
                                        <li>
                                            <img src="/images/cart-info03.svg" alt="" />
                                                <strong>
                                                    {t("moznost_vraceni")}
                                                </strong>
                                                    {t("V Tonak store zdarma")}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <button type={"submit"} className="btn">{t("Pokračovat")}</button>
                        </form>}
                    </section>

                </div>

            </main>
    )
}

CartItems.Layout = Layout


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/cart/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  